module.exports = __webpack_public_path__ + "static/media/mulher-empretec.15131f10.png";